import React from "react";
import Label from "../../../components/Label";
import BarChart from "../../../components/D3Charts/BarChart";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function OverviewMembers({stats={}}) {
  const {t} = useTranslation();

  
  const getData = () => {
    const data = [];
    if (stats?.top_mosques_by_members?.length > 0) {
      stats?.top_mosques_by_members.forEach(element => {
        data.push(element?.total_member_count);
      });
    }
    return data;
  }

  const getCategories = () => {
    const data = [];
    if (stats?.top_mosques_by_members?.length > 0) {
      stats?.top_mosques_by_members.forEach(element => {
        data.push(element?.name);
      });
    }
    return data;
  }

  return (
    <div className="col-12">
    <div className="plan-members">
      <Label variant="text1">{t('Members Overview')}</Label>
      <Label variant="text5" color="#7E7E7E">{t('Total Active Members Per Mosque')}</Label>
      <div className="white_box" style={{ height: "100%"}}>
        <div className="" style={{ height: "100%" }}>
          <div>
            <BarChart
            name="Members"
            data={getData()}
            categories={getCategories()}
            isMemberChart={true}
            />
          </div>
        </div>

      </div>
    </div>
    </div>
  );
}

export default OverviewMembers;
